/* eslint-disable no-console */

import { register } from "register-service-worker";

const Config = {
  START_SW: false
};

function himmel(gen, v) {
  const item = gen.next(v);
  if (item.done) {
    return item.value;
  }

  const { value, done } = item;
  if (value instanceof Promise) {
    value.then(e => himmel(gen, e));
  } else {
    himmel(gen);
  }
}

function isMobile() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true;
  } else {
    return false;
  }
}

function isPc() {
  return !isMobile();
}

function isSw() {
  if ("https:" === location.protocol && navigator.serviceWorker) {
    return true;
  }
  return false;
}

// 清楚service worker缓存，注意：此函数没有卸载service worker
function delSwCaches() {
  return new Promise((resolve, reject) => {
    if ("caches" in window) {
      const _caches = window["caches"];
      _caches.keys().then(cacheNames => {
        if (cacheNames.length) {
          cacheNames.forEach(cacheName => {
            _caches.delete(cacheName);
          });
          resolve(true);
        } else {
          resolve(false);
        }
      });
    } else {
      reject("缓存删除失败");
    }
  });
}
//卸载service worker 注意：此函数没有删除缓存
function unSwRegister() {
  return new Promise((resolve, reject) => {
    if (!isSw()) {
      reject("卸载Server Worker失败");
    }
    if (navigator.serviceWorker.getRegistrations) {
      navigator.serviceWorker.getRegistrations().then(function(registrations) {
        if (registrations.length) {
          for (let registration of registrations) {
            registration.unregister();
          }
          resolve(true);
        } else {
          resolve(false);
        }
      });
    } else if (navigator.serviceWorker.getRegistration) {
      navigator.serviceWorker.getRegistration().then(function(registration) {
        if (registration) {
          registration.unregister();
          resolve(true);
        } else {
          resolve(false);
        }
      });
    }
  });
}

function* clearSw() {
  let cache_flag = yield delSwCaches();
  let reg_flag = yield unSwRegister();
  if (cache_flag || reg_flag) {
    window.location.reload(true);
  }
}

function clearSwSync() {
  if (isSw()) {
    himmel(clearSw());
  }
}

if (process.env.NODE_ENV === "production" && Config.START_SW) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
} else {
  clearSwSync();
}
